// extracted by mini-css-extract-plugin
export default {"heading":"_l-z","createAccount":"am-z","disabled":"bm-z","copy":"cm-z","terms":"dm-z"};